<template>
    <div class="wp">
        <div class="w-1200 communication-post-1">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/communication'}">交流中心</el-breadcrumb-item>
                        <el-breadcrumb-item>发表新帖</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="title-more">
                <div class="t-m-blue"></div>
                <p class="t-m-t">发表新帖</p>
            </div>
            <div class="form">
                <el-form ref="form" :rules="rules" label-position="left" :model="form" label-width="100px">
                    <el-form-item label="标题" prop="titleName">
                        <el-input v-model="form.titleName" placeholder="请输入文章标题"></el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12">
                        
                        <el-form-item label="示范类型" prop="sfType">
                             <el-select v-model="form.sfType">
                            <el-option label="示范设备" value="DEVICE"></el-option>
                             <el-option label="示范应用" value="APP"></el-option>
                              <el-option label="示范技术" value="TECHNOLOGY"></el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="12">
                        <el-form-item label="设备类型" prop="deviceTypeCode">
                            <el-select v-model="form.deviceTypeCode" >
                                <el-option v-for="(item,index) in deviceList" :key="index" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    </el-row>
                    
                    
                     <el-form-item label="地域" prop="area">
                        <el-select v-model="form.province" style="margin-right:20px;" @change="getCities">
                            <el-option v-for="(item,index) in provinces" :key="index" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                        <el-select v-model="form.city" style="margin-right:20px;" @change="getAreas">
                            <el-option v-for="(item,index) in cities" :key="index" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                        <el-select v-model="form.area" style="margin-right:20px;">
                             <el-option v-for="(item,index) in areas" :key="index" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="机构名称" prop="orgCode" style="width:600px;">
                        <el-select v-model="form.orgCode" style="margin-right:20px;" @change="getCities">
                            <el-option v-for="(item,index) in orgList" :key="index" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="文章类型" prop="isCopy">
                        <el-radio-group v-model="form.isCopy">
                        <el-radio label="1">原创</el-radio>
                        <el-radio label="-1">转载</el-radio>
                        </el-radio-group>
                    </el-form-item>
                     <el-form-item class="require-label" label="内容" prop="content">
                         <div style="height:400px;">
                              <quill-editor class="editor" style="height:300px;" ref="myQuillEditor"
                                v-model="content"
                                :options="editorOption"
                                @change="onEditorChange($event)">
                            </quill-editor>
                            
                            <input v-show="false" ref="uploadEditorFile" type="file" :accept="fileAccept.join(',')" @change="uploadEditorFile">
                            <span v-if="contentState" class="content-span">请输入内容</span>
                         </div>
                            
                        
                    </el-form-item>
                    <el-form-item>
                        <el-button style="margin-left:10px;float:right;"  @click="submit('form')">发表文章</el-button>
                        <el-button style="float:right;"  type="primary" @click="emptyArticle">清空列表</el-button>
                        
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import CommunicationPost from './CommunicationPost.js';
export default CommunicationPost;
</script>
<style lang="scss" scoped>
@import './CommunicationPost.scss';
</style>